import http from './api'

const route = 'app/comercial/analiseprodutospersonalizado/'

export default {
  showAnaliseFaturamento: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseProdDevolucao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseProdDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseProdutosKgFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseProdutosKgFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseQuantidadeFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseQuantidadeFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseProdutoFaturamentoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseProdutoFaturamentoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showGraficoFaturamentoKgGrupoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showGraficoFaturamentoKgGrupoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showGraficoFatPrecoMedioGrupoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showGraficoFatPrecoMedioGrupoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseFaturamentoGrupoProdutosClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseFaturamentoGrupoProdutosClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showFaturamentoGrupoMesClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showFaturamentoGrupoMesClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseProdutoDevolucaoClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseProdutoDevolucaoClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },
}
